<template>
  <FieldValidate
    :as="as"
    :id="name"
    :name="name"
    :required="isRequired"
    :inputmode="inputmode"
    v-maska="formattedMask"
    v-bind="attrs"
    validate-on-input
    data-testid="standardInput"
    :class="[inputClass, { 'grp-input-main-error': errors[name], filled: isFilled }]"
  />
  <BaseLabel :for-name="name" :label="label" />
  <div class="standard-input-wrapper" style="position: relative; display: flex; align-items: center">
    <img v-if="cardBrand" :src="getCardBrandLogo(cardBrand)" :alt="`Bandeira ${cardBrand}`" class="card-flag-icon" />
  </div>
</template>

<script>
import { computed, toRefs } from 'vue';
import BaseLabel from '@/components/BaseLabel';
import { Field as FieldValidate, useField } from 'vee-validate';

const cardBrandMap = {
  visa: require('@/assets/img/card-flags/flat-rounded/visa.svg'),
  mastercard: require('@/assets/img/card-flags/flat-rounded/mastercard.svg'),
  elo: require('@/assets/img/card-flags/flat-rounded/elo.svg'),
  american_express: require('@/assets/img/card-flags/flat-rounded/american_express.svg'),
  hipercard: require('@/assets/img/card-flags/flat-rounded/hipercard.svg'),
  diners_club: require('@/assets/img/card-flags/flat-rounded/diners_club.svg'),
  discover: require('@/assets/img/card-flags/flat-rounded/discover.svg'),
  generic: require('@/assets/img/card-flags/flat-rounded/generic.svg'),
};

export default {
  name: 'StandardInput',
  components: { BaseLabel, FieldValidate },
  props: {
    label: { type: Object, required: false, default: () => null },
    inputmode: { type: String, required: false, default: '' },
    as: { type: String, required: true },
    name: { type: String, required: true },
    cardBrand: { type: String, required: false, default: '' },
    errors: { type: Object, required: true },
    mask: { type: Array, default: () => [] },
    attrs: { type: Object, required: true, default: () => {} },
  },
  setup(props) {
    const { attrs, mask, name } = toRefs(props);
    const { value: inputValue } = useField(name);

    const inputClass = computed(() => (attrs.value?.colorMode === 'light' ? 'grp-input-light' : 'grp-input-main'));

    const formattedMask = computed(() => {
      const availableMasks = mask.value.length;
      if (!availableMasks) {
        return;
      }

      return availableMasks > 1 ? mask.value : `${mask.value[0]}`;
    });

    const isRequired = computed(() => attrs.value.rules?.includes('required'));
    const isFilled = computed(() => inputValue.value && inputValue.value.length > 0);

    function getCardBrandLogo(brand) {
      return require(`@/assets/img/card-flags/flat-rounded/${brand}.svg`);
    }

    return { formattedMask, isRequired, inputClass, isFilled, getCardBrandLogo };
  },
};
</script>

<style scoped>
.card-flag-icon {
  max-width: 42px;
  max-height: 50px;
  object-fit: contain;
  position: absolute;
  right: 12px;
  top: 0%;
  transform: translateY(-2.3rem);
  z-index: 2;
  border-radius: 3px;
  padding: 2px;
}
</style>
